import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'
import vueCountryRegionSelect from 'vue3-country-region-select'

// 导入语言包
import en from './locales/en.json'
import es from './locales/es.json'
import zh from './locales/zh.json'

// 获取保存的语言或检测系统语言
const getInitialLocale = () => {
  // 1. 尝试从localStorage读取保存的语言
  const savedLocale = localStorage.getItem('userLocale')
  if (savedLocale && ['zh', 'en', 'es'].includes(savedLocale)) {
    return savedLocale
  }
  
  // 2. 如果没有保存的语言，检测系统语言
  const systemLang = navigator.language || navigator.userLanguage || 'en'
  
  // 检查是否为中文
  if (systemLang.startsWith('zh')) {
    return 'zh'
  }
  // 检查是否为英语
  else if (systemLang.startsWith('en')) {
    return 'en'
  }
  // 检查是否为西班牙语
  else if (systemLang.startsWith('es')) {
    return 'es'
  }
  // 其他语言默认显示英语
  else {
    return 'en'
  }
}

const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(), // 使用动态检测的语言
  fallbackLocale: 'en',
  messages: {
    en,
    es,
    zh
  }
})

const app = createApp(App)
app.use(i18n)
app.use(router)
app.use(vueCountryRegionSelect)
app.mount('#app')